/* istanbul ignore file */
/**
 * Context Menu component theme configuration.
 */

export const contextMenuComponentConfig = {
  contextmenu: {
    root: {
      background: '{surface.0}',
      borderColor: '{surface.0}',
      color: '{surface.950}',
      borderRadius: '{border.radius.none}',
      shadow: '{overlay.navigation.shadow}',
      transitionDuration: '{transition.duration}',
    },
    list: {
      padding: '{navigation.list.padding}',
      gap: '{navigation.list.gap}',
    },
    item: {
      focusBackground: '{greymatter.50}',
      activeBackground: '{surface.100}',
      color: '{list.option.color}',
      focusColor: '{list.option.focus.color}',
      activeColor: '{surface.950}',
      padding: '{list.option.padding}',
      borderRadius: '{navigation.item.border.radius}',
      gap: '{navigation.item.gap}',
      icon: {
        color: '{list.option.icon.color}',
        focusColor: '{list.option.focus.color}',
        activeColor: '{surface.800}',
      },
      focusRing: {
        shadow: 'inset {form.field.focus.ring.shadow}',
      },
    },
    submenu: {
      mobileIndent: '1rem',
    },
    submenuIcon: {
      size: '16px',
      color: '{surface.600}',
      focusColor: '{surface.600}',
      activeColor: '{surface.600}',
    },
    separator: {
      borderColor: '{content.border.color}',
    },
  },
};
